import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCurrentUserDetails } from "./common/routines/user-operations";
import { routes } from "./constants/routes";

interface ProtectedPreneedRouteProps {
  children: React.ReactElement;
  moduleName: string;
  fallbackPath?: string;
}

const ProtectedPreneedRoute = ({
  children,
  moduleName,
  fallbackPath = "/unauthorized",
}: ProtectedPreneedRouteProps) => {
  const location = useLocation();

  const preNeed = getCurrentUserDetails("preNeed");
  const isAuthenticated =
    !!preNeed?.accessToken &&
    (!!preNeed?.expiryTime ? preNeed.expiryTime > Date.now() : true);

  if (!isAuthenticated) {
    return (
      <Navigate
        to={routes.PRENEED_LOGIN}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedPreneedRoute;
